<template>
  <div>
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{$t('route.disinfectionManage')}}</el-breadcrumb-item>
      <el-breadcrumb-item>接入厂商</el-breadcrumb-item>
      <el-breadcrumb-item>设备型号</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="contentWrapper disinfectList">
      <div class="buttonshebei">
        <el-button type="primary" class="shebeibuttonson" @click="newtodisbin"
          >添加设备型号</el-button
        >
      </div>
        <!-- <div class="title">{{ $t("robot.timedTask") }}</div> -->
        <el-table :data="tableDatatiming" style="width: 100%" class="taskList">
          <!-- :class="{'cursorpointers':tableDatatiming.length>0}" -->
          <el-table-column prop="deviceName" :label="'设备名称'" />
          <el-table-column prop="deviceModel" :label="'设备型号'" />
          <el-table-column prop="companyName" :label="'厂商'" />
          <!-- <el-table-column prop="uvTime" :label="'消毒时长'" /> -->
          <el-table-column :label="'消毒时长'" >
          <template #default="scope">
            <!-- <div>{{scope.row.uvTime<60?scope.row.uvTime+'s':scope.row.uvTime+'s'}}</div> -->
            <div>{{parseInt(scope.row.uvTime/60)+'min' + (scope.row.uvTime%60 !=0?scope.row.uvTime%60+'s':'')}}</div>
          </template>
           </el-table-column>
          <!-- <el-table-column prop="operation" label="操作"  @click="removetimingtask" /> -->
          <el-table-column :label="$t('system.operation')" width="100">
            <template #default="scope">
              <el-button
                type="text"
                size="small"
                @click.stop="setdisbin(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="removebin(scope.$index, scope.row)"
                >{{ $t("disinfect.shanchu") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      <el-dialog
        v-model="todisbinfalge"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal="false"
        :title="setconfim==='set'?'编辑设备型号':'添加设备型号'"
        width="40%"
        center
        :show-close="false"
        v-if="todisbinfalge"
      >
        <div class="chanshangty">
          <div class="mingzi">设备名称</div>
          <el-input
            v-model.trim="inputsbmc"
            class="inputchanshang"
            placeholder="请输入设备名称(必填)"
            size="mini"
          />
        </div>
        <div class="plaeasecsmz">
          <!-- 请输入设备名称 -->
          {{ pleaase1}}
        </div>
        <div class="chanshangty">
          <div class="mingzi">设备型号</div>
          <el-input
            v-model.trim="inputdizhi"
            class="inputchanshang"
            placeholder="请输入设备型号(必填)"
            size="mini"
          />
        </div>
        <div class="plaeasecsmz">
          <!-- 请输入设备型号 -->
          {{ pleases2 }}
        </div>
        <div class="chanshangty chanshangpostion">
          <div class="mingzi">消毒时长</div>
          <el-input
            @click="killtrue"
            v-model="inputkilltrue"
            class="inputchanshang"
            placeholder="请设置消杀时长(必填)"
            size="mini"
            :readonly="true"
          />
          <Todiskilltime
            ref="todiskilltime"
            @timesvaluedurion="timesvaluedurion"
          />
        </div>
        <div class="plaeasecsmz">
          <!-- 请选择消毒时长 -->
          {{ pleases3 }}
        </div>
        <div class="chanshangty">
          <div class="mingzi">厂商</div>
          <div>{{ inputchanshang }}</div>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="canceltodis">取消</el-button>
            <el-button type="primary" @click="Shutdowntodis">确定</el-button>
          </span>
        </template>
      </el-dialog>
      <el-dialog
        v-model="deletecompanyfalge"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :title="'删除设备型号'"
        width="30%"
        center
        :show-close="false"
      >
        <div class="algincenter">
          将删除设备型号: {{ deletedetail.deviceModel }}
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="canceltingflage">{{
              $t("system.cancel")
            }}</el-button>
            <el-button type="primary" @click="detelechangshang(deletedetail)"
              >{{ $t("system.determine") }}
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  ref,
  onMounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import Todiskilltime from "@/components/todiskilltime/index.vue";
import { ElMessage } from 'element-plus'
import { typeLists, addTypes, deleteTypes, updateTypes } from "@/apis/group";
export default defineComponent({
  components: {
    Todiskilltime,
  },
  setup() {
    let todiskilltime = ref();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      tableDatatiming: [],
      todisbinfalge: false,
      inputchanshang: "",
      inputdizhi: "",
      inputbeizhu: "",
      pleaase1: "",
      pleases3: "",
      setconfim: "",
      inputkilltrue: "1min",
      inputkillnumber: 60,
      inputsbmc: "",
      deletecompanyfalge: false,
      deletedetail: null,
      typeid:null,
      pleases2:''
    });
    const method = reactive({
      killtrue(): void {
        if (state.setconfim === "set") {
          method.setkillsj(state.inputkillnumber);
        }
        todiskilltime.value.timeflage = true;
      },
      setkillsj(numberss: any): void {
        todiskilltime.value.overindex = Math.floor(numberss / 60);
        todiskilltime.value.overmiaoindex = numberss % 60;
        todiskilltime.value.defaultValuefen = Math.floor(numberss / 60);
        todiskilltime.value.defaultValuemiao = numberss % 60;
      },
      timesvaluedurion(value1: any, value2: any) {
        state.inputkilltrue =
          value1 + "min" + (value2 === 0 ? "" : value2 + "s");
        state.inputkillnumber = value1 * 60 + value2;
      },
      setdisbin(index: number, rows: any) {
        state.setconfim = "set";
        console.log(index, rows);
        state.inputsbmc = rows.deviceName;
        state.inputdizhi = rows.deviceModel;
        state.inputbeizhu = rows.uvTime;
        state.inputkilltrue =
          Math.floor(rows.uvTime / 60) +
          "min" +
          (rows.uvTime % 60 === 0 ? "" : (rows.uvTime % 60) + "s");
        state.inputkillnumber = rows.uvTime;
        state.typeid = rows.deviceId
        state.todisbinfalge = true;
      },
      removebin(index: number, rows: any) {
        console.log(index, rows);
        state.deletedetail = rows;
        //   state.timingtaskdetail = rows;
        //   state.timingindex = index;
        state.deletecompanyfalge = true;
      },
      detelechangshang(elsa: any) {
        deleteTypes({
          id: elsa.deviceId,
        }).then((resdea: any) => {
          console.log(resdea);
          if (resdea.code === 200) {
            method.gettyplistss();
            state.deletecompanyfalge = false;
          }
        });
      },
      newtodisbin() {
        state.setconfim = "add";
        state.todisbinfalge = true;
        state.inputkillnumber = 60;
      },
      canceltodis() {
        state.todisbinfalge = false;
        nextTick(() => {
          state.pleaase1 = "";
          state.pleases3 = "";
          state.inputdizhi = "";
          state.inputbeizhu = "";
          if (state.setconfim === "add") {
            state.inputkilltrue = '1min';
            state.inputkillnumber = 60
          }
          state.inputsbmc = "";
        });
      },
      canceltingflage() {
        state.deletecompanyfalge = false
      },
      gettyplistss() {
        typeLists({
          ids: route.params.ids,
        }).then((ssres: any) => {
          console.log(ssres);
          state.tableDatatiming = ssres.data.typeList;
          state.inputchanshang = ssres.data.vendorName
        });
      },
      Shutdowntodis() {
        if (state.inputsbmc === "") {
          state.pleaase1 = "请输入设备名称";
          state.pleases3 = "";
           state.pleases2 = ''
        } else if (state.inputdizhi === '') {
          state.pleases2 = '请输入设备型号'
          state.pleaase1 = "";
          state.pleases3 = '';
        } else if (state.inputkillnumber === null) {
          state.pleases3 = "请选择消毒时间";
          state.pleaase1 = "";
          state.pleases2 = "";
        } else {
          if (state.setconfim === "set") {
            console.log("我是设置");
            updateTypes({
              deviceModel: state.inputdizhi,
              deviceName: state.inputsbmc,
              deviceid: state.typeid,
              uvTime: state.inputkillnumber
            }).then((updatyperes:any)=>{
              console.log(updatyperes)
              if (updatyperes.code === 200) {
                ElMessage({
                  message:'编辑设备型号成功',
                  type:'success'
                })
                method.gettyplistss();
                state.todisbinfalge = false;
                nextTick(() => {
                  state.pleaase1 = "";
                  state.pleases3 = "";
                  state.inputdizhi = "";
                  state.inputbeizhu = "";
                  state.inputkilltrue = "";
                  state.inputsbmc = "";
                  state.typeid = null
                  state.pleases2 = ''
                });
              } else {
                 ElMessage({
                  message:updatyperes.msg
                })
              }
            })
          } else {
            console.log("我是新增");
            addTypes({
              companyid: route.params.ids,
              deviceModel: state.inputdizhi,
              deviceName: state.inputsbmc,
              uvTime: state.inputkillnumber,
            }).then((addres: any) => {
              console.log(addres);
              if (addres.code === 200) {
                ElMessage({
                  message:'添加设备型号成功',
                  type:'success'
                })
                method.gettyplistss();
                state.todisbinfalge = false;
                nextTick(() => {
                  state.pleaase1 = "";
                  state.pleases3 = "";
                  state.inputdizhi = "";
                  state.inputbeizhu = "";
                  state.inputkilltrue = "1min";
                  state.inputkillnumber = 60
                  state.inputsbmc = "";
                  state.pleases2 = ''
                });
              } else {
                 ElMessage({
                  message:addres.msg
                })
              }
            });
          }
        }
      },
    });
    onMounted(() => {
      method.gettyplistss();
    });
    return {
      ...toRefs(state),
      ...toRefs(method),
      todiskilltime,
    };
  },
});
</script>
<style lang="scss" scoped>
.algincenter{
  text-align: center;
}
.disinfectList {
  position: relative;
  min-height: 300px;
  max-height: 100%;
  font-size: 12px;
  .chanshangty {
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  .mingzi {
    text-align: right;
    margin-right: 2%;
    width: 13%;
  }
  .inputchanshang {
    width: 85%;
  }
  .buttonshebei {
    width: 100%;
    height: 40px;
    position: relative;
    .shebeibuttonson {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .taskList{
    margin-top: 15px;
  }
  .plaeasecsmz {
    height: 30px;
    line-height: 30px;
    color: red;
    padding-left: 20%;
  }
  .chanshangpostion {
    position: relative;
  }
}
</style>